import { CONSTANTS } from 'src/components/Constants';

// The roles routes/pedigree_ai.js lets through. Both of its routes ask
// enforce('pedigrees', 'write'), which admits these four (a Genetics User as far
// as their security groups allow) and no patient, and the router refuses a
// student before that. A role not yet read is not offered it either.
const SKETCH_ROLES = Object.freeze([
  CONSTANTS.userTypes.ADMIN,
  CONSTANTS.userTypes.GENETICS,
  CONSTANTS.userTypes.GENETICS_SERVICE_ADMIN,
  CONSTANTS.userTypes.GENETICS_USER
]);

/**
 * Is the Pedigree sketch launcher offered on this canvas?
 *
 * Hidden in the same three cases the legend box is (an FHQ preview, a PERSON tab,
 * which has no canvas, and a locked pedigree), on the patient portal's view of a
 * pedigree, while the admin switch is off, and to anyone the sketch's routes
 * would refuse. `GET /va/feature-flags` is the deployment's answer, not the
 * user's, so the user's half is decided here: `canWritePedigrees` is
 * SgAccessContext's canWrite('pedigrees'), the security-group rule the server's
 * enforce() applies, false for a read-only group.
 *
 * @returns {boolean}
 */
export const showSketchLauncher = ({
  preview,
  patient,
  personMemberId,
  isLocked,
  sketchEnabled,
  userType,
  canWritePedigrees
}) =>
  !preview &&
  !patient &&
  !personMemberId &&
  !isLocked &&
  !!sketchEnabled &&
  SKETCH_ROLES.includes(userType) &&
  canWritePedigrees === true;
